import { ISoftEdgeFeature } from '@framework/workbench/drawer/ui/effects/soft-edge/soft-edge-interface';
import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import { IEffectModelValCollection } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';

export interface IChartSoftEdgeFeature extends ISoftEdgeFeature {}

export const IChartSoftEdgeFeature = Symbol.for('feature:chart-global-soft-edge');

DynamicLoaderRegistry.merge(IChartSoftEdgeFeature, {
    useFactory: async () => {
        const { ChartSoftEdgeFeature } = await import('./chart-soft-edge-feature');
        return ChartSoftEdgeFeature;
    },
    on: loadTask,
});
